"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_demi_1 = require("vue-demi");
const ModuleWrapper_vue_1 = tslib_1.__importDefault(require("../../assets/uis/containers/ModuleWrapper.vue"));
const StockCard_vue_1 = tslib_1.__importDefault(require("../../assets/uis/containers/StockCard.vue"));
const Divider_vue_1 = tslib_1.__importDefault(require("../../assets/uis/Divider.vue"));
const IntroText_vue_1 = tslib_1.__importDefault(require("../../assets/uis/IntroText.vue"));
const MoreButton_vue_1 = tslib_1.__importDefault(require("../../assets/uis/MoreButton.vue"));
const TagList_vue_1 = tslib_1.__importDefault(require("../../assets/uis/TagList.vue"));
const enum_1 = require("../../common/enum");
const scheme_1 = require("../../common/scheme");
const useI18n_1 = require("../../common/useI18n");
const fegoProps_1 = require("../../models/fegoProps");
const AIAnalysisPopup_vue_1 = tslib_1.__importDefault(require("../_cards/AIAnalysisPopup.vue"));
const AIAnalyst_vue_1 = tslib_1.__importDefault(require("../_cards/AIAnalyst.vue"));
const MarketPositionOverview_vue_1 = tslib_1.__importDefault(require("../_cards/MarketPositionOverview.vue"));
const StockQuote_vue_1 = tslib_1.__importDefault(require("../_cards/StockQuote.vue"));
const __sfc_main = {};
__sfc_main.props = {
    introTitle: {
        type: String,
        default: ''
    },
    signalData: {
        type: Object,
        default: undefined
    },
    languageId: {
        type: Number,
        default: useI18n_1.LanguageId.EN
    },
    upDownColor: {
        type: Number,
        default: enum_1.UP_DOWN_COLOR.GREEN_UP
    },
    selfSelectedMap: {
        type: Object,
        default: () => ({})
    },
    wchNumMap: {
        type: Object,
        default: () => ({})
    },
    showWchNum: {
        type: Boolean,
        default: true
    },
    aiAnalysisMap: {
        type: Object,
        default: () => ({})
    },
    pageType: {
        type: Number,
        default: fegoProps_1.SignalSelectedPageType.PRIMARY
    },
    viewMoreUrl: {
        type: String,
        default: undefined
    },
    platform: {
        type: String,
        default: scheme_1.PLATFORM_TYPE.MOOMOO
    }
};
__sfc_main.setup = (__props, __ctx) => {
    const props = __props;
    const emit = __ctx.emit;
    // 多语言
    const languageId = (0, vue_demi_1.computed)(() => props.languageId);
    const $t = (0, useI18n_1.useI18n)(props.languageId);
    // 涨跌色
    const upDownColor = (0, vue_demi_1.computed)(() => props.upDownColor);
    // 处理自选点击
    const handleToggleSelfSelected = (stockId, $event) => {
        emit('toggle-self-selected', stockId, $event);
    };
    const tags = (0, vue_demi_1.ref)([]);
    const introText = (0, vue_demi_1.ref)('');
    const stockList = (0, vue_demi_1.ref)([]);
    const updateTime = (0, vue_demi_1.ref)(undefined);
    const expandedCards = (0, vue_demi_1.ref)([]);
    // AI 分析弹窗状态
    const aiPopupVisible = (0, vue_demi_1.ref)(false);
    const currentAIAnalysis = (0, vue_demi_1.reactive)({
        stockId: '',
        name: '',
        updatedTime: '',
        content: '',
        introTitle: ''
    });
    // 监听 signalData 变化，更新内部状态
    (0, vue_demi_1.watch)(() => props.signalData, newData => {
        if (newData) {
            tags.value = newData.tags;
            introText.value = newData.introText;
            stockList.value = newData.stockList;
            updateTime.value = newData.updateTime;
            // 初始化展开状态数组，默认展开第一个卡片
            expandedCards.value = newData.stockList.map((_, index) => index === 0);
        }
    }, {
        immediate: true
    });
    const toggleCard = (index) => {
        expandedCards.value[index] = !expandedCards.value[index];
    };
    const handleMore = () => {
        if (props.viewMoreUrl) {
            window.open(props.viewMoreUrl, '_blank');
        }
    };
    // 打开 AI 分析弹窗
    const openAIAnalysisPopup = (stock) => {
        const aiAnalysis = props.aiAnalysisMap[stock.stockId];
        if (aiAnalysis) {
            currentAIAnalysis.name = stock.shortName;
            currentAIAnalysis.updatedTime = aiAnalysis.updatedTime || '';
            currentAIAnalysis.content = aiAnalysis.content || '';
            currentAIAnalysis.introTitle = aiAnalysis.title || '';
            currentAIAnalysis.stockId = stock.stockId;
            aiPopupVisible.value = true;
        }
    };
    const { jumpToAskAi, jumpToStock, jumpToChipDistribution } = (0, scheme_1.useJump)(props);
    // AI 分析弹窗按钮事件
    const handleAskAIMore = () => {
        jumpToAskAi(currentAIAnalysis.stockId);
    };
    const handleViewStockDetails = () => {
        jumpToStock(currentAIAnalysis.stockId);
    };
    return {
        SignalSelectedPageType: fegoProps_1.SignalSelectedPageType,
        languageId,
        $t,
        upDownColor,
        handleToggleSelfSelected,
        tags,
        introText,
        stockList,
        updateTime,
        aiPopupVisible,
        currentAIAnalysis,
        handleMore,
        openAIAnalysisPopup,
        jumpToStock,
        jumpToChipDistribution,
        handleAskAIMore,
        handleViewStockDetails
    };
};
__sfc_main.components = Object.assign({
    ModuleWrapper: ModuleWrapper_vue_1.default,
    TagList: TagList_vue_1.default,
    IntroText: IntroText_vue_1.default,
    StockCard: StockCard_vue_1.default,
    StockQuote: StockQuote_vue_1.default,
    Divider: Divider_vue_1.default,
    MarketPositionOverview: MarketPositionOverview_vue_1.default,
    AIAnalyst: AIAnalyst_vue_1.default,
    MoreButton: MoreButton_vue_1.default,
    AIAnalysisPopup: AIAnalysisPopup_vue_1.default
}, __sfc_main.components);
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,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